import { Link, useParams, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import { Car, Motorcycle, Truck, CheckCircle, ArrowRight, Clock, Trophy, ShieldCheck, Lightning, Phone, WhatsappLogo, MapPin, Star, Coin } from "@phosphor-icons/react";
import PriceAdvisorModal from "@/components/PriceAdvisorModal";

const ICONS = { Car, Motorcycle, Truck };

// Detailed, SEO-rich content for each course
const COURSE_PAGES = {
  "b-sinifi": {
    code: "B", name: "B Sınıfı (Manuel) Ehliyet Kursu", icon: "Car",
    seo_title: "B Sınıfı Ehliyet Kursu Gebze | Manuel Vites | Estem Sürücü Kursu",
    seo_desc: "Gebze'de B sınıfı manuel ehliyet kursu. 37 yıllık tecrübe, 33.000+ mezun. Teorik 34 saat + direksiyon 14 saat. Taksitli ödeme. Hemen kayıt ol!",
    min_age: 18, price: 8500, duration: "34 saat teorik + 14 saat direksiyon",
    hero_h1: "Gebze'de B Sınıfı Ehliyet Almanın En Hızlı Yolu",
    intro: "B sınıfı ehliyet, Türkiye'de en çok tercih edilen sürücü belgesidir. Estem Sürücü Kursu olarak Gebze'de 37 yıldır binlerce kursiyeri B sınıfı ehliyet sahibi yaptık.",
    benefits: ["Otomobil, panelvan, kamyonet kullanma yetkisi","9 koltuğa kadar manuel + otomatik tüm araçlar","Karavan ve hafif römork çekme hakkı","B sınıfı sınavı 1. denemede geçme oranımız %87"],
    why_us: ["8 farklı eğitim aracı (Renault, Fiat, Volkswagen)","Hafta sonu yoğun program seçeneği","Geçemeyen kursiyere ücretsiz takviye","E-sınav simülasyonu ücretsiz"],
    long_content: "B sınıfı ehliyet kursu, 18 yaşını dolduran her sağlıklı bireyin alabileceği temel sürücü belgesidir. Estem Sürücü Kursu'nda B sınıfı eğitiminiz; MEB müfredatına uygun 34 saatlik teorik ders, 14 saatlik direksiyon uygulaması ve sınav öncesi prova güzergahları ile tamamlanır. Gebze ve çevre ilçelerden gelen kursiyerlerimiz için merkezi konumumuz büyük avantaj sağlar. Hacı Halil Mahallesi'ndeki ofisimizde modern sınıflar, simülasyon odaları ve 13 aktif eğitim aracımız sizi bekliyor.",
  },
  "b-otomatik": {
    code: "B-Auto", name: "B Sınıfı Otomatik Vites Ehliyet", icon: "Car",
    seo_title: "B Otomatik Ehliyet Kursu Gebze | Sadece Otomatik | Estem",
    seo_desc: "Sadece otomatik vitesli araç kullanacaksanız B otomatik ehliyet sizin için ideal. Gebze Estem'de hızlı ve kolay eğitim. Online kayıt.",
    min_age: 18, price: 8500, duration: "34 saat teorik + 14 saat direksiyon (otomatik araç)",
    hero_h1: "Sadece Otomatik. Sadece Şehir. Sadece Estem.",
    intro: "Manuel vites kullanmayacaksanız, B otomatik ehliyet öğrenme sürenizi kısaltır ve sınav stresinizi azaltır.",
    benefits: ["Sadece otomatik vitesli araç kullanım yetkisi","Daha hızlı öğrenme süreci","Şehir içi sürüş için ideal","Stressiz sınav deneyimi"],
    why_us: ["Modern otomatik vitesli eğitim araçları","Stop yapma derdi olmadan rahat öğrenme","Direksiyon sınavında %92 başarı oranı","Geçemeyen kursiyere ücretsiz takviye"],
    long_content: "B otomatik ehliyet özellikle şehir içi sürüş yapacak, manuel vites kullanmayı tercih etmeyen kursiyerler için idealdir. Estem Sürücü Kursu'nda otomatik vitesli modern araçlarla eğitim alır, kısa sürede direksiyon sınavına hazır hale gelirsiniz.",
  },
  "a1": {
    code: "A1", name: "A1 Sınıfı Motosiklet Ehliyet Kursu", icon: "Motorcycle",
    seo_title: "A1 Motosiklet Ehliyeti Gebze | 125cc | 16 Yaş | Estem",
    seo_desc: "16 yaşındaysan A1 motosiklet ehliyeti senin için. 125 cc'ye kadar motosiklet kullanma yetkisi. Gebze Estem'de uygun fiyat, kolay kayıt.",
    min_age: 16, price: 5500, duration: "24 saat teorik + 12 saat direksiyon",
    hero_h1: "16 Yaşındaysan, A1 Tam Sana Göre",
    intro: "A1 sınıfı ehliyet, 125 cc'ye kadar motosikletleri kullanmana izin veren ehliyet sınıfıdır. Şehirde hareket özgürlüğünü ergenlik döneminde kazan.",
    benefits: ["125 cc'ye kadar tüm motosikletler","Şehir içi pratik ulaşım","16 yaşından itibaren alınabilir","Yakıt tasarrufu + park kolaylığı"],
    why_us: ["Eğitim motosikletlerimiz tam donanımlı","Pist eğitimi + trafik prova","Lise öğrencilerine özel saat planlaması","Veliler için bilgilendirme toplantısı"],
    long_content: "A1 motosiklet ehliyeti, motosiklet tutkunu gençlerin ilk durağıdır. 16 yaşını doldurmuş herkes, velisinin onayı ile A1 kursuna kaydolabilir. Estem'de motosiklet eğitimimiz hem kapalı pistte hem de gerçek trafik şartlarında yapılır.",
  },
  "a2": {
    code: "A2", name: "A2 Sınıfı Motosiklet Ehliyet Kursu", icon: "Motorcycle",
    seo_title: "A2 Motosiklet Ehliyeti Gebze | 35 kW altı | 18 Yaş | Estem",
    seo_desc: "A2 motosiklet ehliyeti ile 35 kW altındaki tüm motosikletleri kullan. Gebze'nin köklü kursu Estem'de güvenli motosiklet eğitimi.",
    min_age: 18, price: 6000, duration: "24 saat teorik + 12 saat direksiyon",
    hero_h1: "A2 — Yolu hisset, hızını ayarla.",
    intro: "A2 motosiklet ehliyeti, 35 kW (yaklaşık 47 BG) altındaki motosikletleri kullanma yetkisi verir. 18 yaşını dolduran herkes başvurabilir.",
    benefits: ["35 kW altı tüm motosikletler","Daha güçlü makineler için ilk basamak","2 yıl sonra A sınıfına geçiş hakkı","Sportif & retro motosikletler dahil"],
    why_us: ["Deneyimli motosiklet eğitmenleri","Defensive riding (savunmacı sürüş) modülü","Yağmurlu hava sürüş eğitimi","Sınav güzergahında prova"],
    long_content: "A2 sınıfı ehliyet, motosiklet kültürüne adım atmak isteyenlerin en yaygın tercihidir. Estem'in deneyimli motosiklet eğitmenleri, sadece sınavı geçmeniz için değil, hayat boyu güvenli sürücü olmanız için eğitir.",
  },
  "a": {
    code: "A", name: "A Sınıfı Motosiklet Ehliyet Kursu", icon: "Motorcycle",
    seo_title: "A Sınıfı Motosiklet Ehliyeti Gebze | Sınırsız Güç | Estem",
    seo_desc: "A sınıfı motosiklet ehliyeti ile her motosikleti kullan. 24 yaş veya 2 yıllık A2 sahipliği şartı. Gebze Estem'de profesyonel eğitim.",
    min_age: 24, price: 6500, duration: "24 saat teorik + 12 saat direksiyon",
    hero_h1: "A Sınıfı — Sınırları Aşmak İçin",
    intro: "A sınıfı motosiklet ehliyeti, 35 kW üzerindeki tüm motosikletleri kullanma yetkisi verir. Süperbike ve büyük tur motosikletleri için tek seçenek.",
    benefits: ["Sınırsız güç, sınırsız motosiklet","Süperbike & tur motosikletleri","ABD/AB ülkelerinde geçerli","Motorcular için prestij"],
    why_us: ["Yüksek kw'lı eğitim motosikletleri","İleri sürüş teknikleri eğitimi","Uzun mesafe sürüş ipuçları","Motosiklet topluluğumuza erişim"],
    long_content: "A sınıfı ehliyet motosiklet hobisinin tepe noktasıdır. 24 yaşını dolduran veya 2 yıllık A2 ehliyetine sahip kursiyerlerimiz, Estem'in deneyimli eğitmenleriyle güç motosikletlerini güvenle yönetmeyi öğrenir.",
  },
};

// Course-specific FAQs
const COURSE_FAQS = {
  "b-sinifi": [
    { q: "B sınıfı ehliyet için minimum yaş nedir?", a: "18 yaş. 18 yaşını dolduran her sağlıklı birey B sınıfı ehliyet kursu başvurusu yapabilir." },
    { q: "B sınıfı ehliyet kaç saatlik eğitim gerektirir?", a: "34 saat teorik ders + 14 saat direksiyon uygulaması zorunludur. Toplam süreç 2–3 ay sürer." },
    { q: "Gebze'de B sınıfı ehliyet fiyatı ne kadar?", a: "Estem Sürücü Kursu'nda 2026 yılı B sınıfı kurs ücreti 8.500₺'den başlamaktadır. Taksit imkanı mevcuttur." },
    { q: "B sınıfı ehliyet ile hangi araçlar kullanılır?", a: "Otomobil, hafif ticari araç (panelvan, kamyonet), 9 koltuğa kadar minibüs ve karavan çekebilirsiniz." },
  ],
  "b-otomatik": [
    { q: "B otomatik ehliyet ile manuel araç kullanabilir miyim?", a: "Hayır. B otomatik ehliyet yalnızca otomatik vitesli araçlar için geçerlidir." },
    { q: "B otomatik ehliyet daha kolay mı alınır?", a: "Manuel vites öğrenme stresi olmadığından birçok kursiyer daha kolay bulur. Direksiyon sınavı başarı oranımız %92'dir." },
    { q: "B otomatik ehliyet fiyatı ne kadar?", a: "B manuel ile aynı: 8.500₺. Taksit imkanı mevcuttur." },
  ],
  "a1": [
    { q: "A1 motosiklet ehliyeti için minimum yaş kaç?", a: "16 yaş. Veli onayı ile 16 yaşından itibaren başvuru yapılabilir." },
    { q: "A1 ile hangi motosikletler kullanılır?", a: "Motor gücü 11 kW ve motor hacmi 125cc'yi aşmayan motosikletler. Şehir içi ulaşım için idealdir." },
    { q: "Gebze'de A1 ehliyet kursu ne kadar?", a: "Estem'de A1 motosiklet ehliyeti 5.500₺'den başlamaktadır." },
    { q: "A1'den A2'ye geçiş nasıl olur?", a: "18 yaşını doldurduktan ve A1 ehliyetinizi en az 2 yıl taşıdıktan sonra A2 sınavına girebilirsiniz." },
  ],
  "a2": [
    { q: "A2 motosiklet ehliyeti için minimum yaş kaç?", a: "18 yaş. 18 yaşını dolduran herkes A2 sınıfına başvurabilir." },
    { q: "A2 ehliyetiyle hangi motosikletler kullanılır?", a: "Motor gücü 35 kW (47 BG) ile sınırlı araçlar. Sportif ve retro motosikletlerin büyük çoğunluğu bu sınıfa girer." },
    { q: "A2'den A sınıfına geçiş ne zaman mümkün?", a: "A2 ehliyetine 2 yıl sahip olduktan sonra veya 24 yaşında direkt A sınıfı alınabilir." },
    { q: "Gebze'de A2 kursu ücreti nedir?", a: "Estem'de A2 motosiklet kursu 6.000₺'den başlamaktadır." },
  ],
  "a": [
    { q: "A sınıfı motosiklet ehliyeti için şartlar nedir?", a: "24 yaşını doldurmuş olmak VEYA en az 2 yıl boyunca A2 ehliyetine sahip olmak gerekir." },
    { q: "A sınıfı ile hangi araçlar kullanılır?", a: "Güç sınırlaması olmaksızın tüm motosikletler. Süperbike, büyük tur motosikletleri ve sınırsız kW araçlar dahil." },
    { q: "Gebze'de A sınıfı kursu ne kadar?", a: "Estem'de A sınıfı motosiklet ehliyeti 6.500₺'den başlamaktadır." },
  ],
};


export default function CoursePage() {
  const { slug } = useParams();
  const c = COURSE_PAGES[slug];
  const [priceModal, setPriceModal] = useState(false);

  // code → price advisor class code mapping
  const COURSE_TO_CLASS = { "B": "B", "B-Auto": "B-Auto", "A1": "A1", "A2": "A2", "A": "A" };
  const advisorClass = c ? COURSE_TO_CLASS[c.code] : null;
  const faqs = COURSE_FAQS[slug] || [];

  useEffect(() => {
    if (!c) return;
    const base = "https://www.estemsurucukursu.com";
    const schemas = [
      {
        "@context": "https://schema.org",
        "@type": "Course",
        "name": c.name,
        "description": c.seo_desc,
        "provider": { "@type": "Organization", "name": "Estem Sürücü Kursu", "sameAs": base },
        "offers": { "@type": "Offer", "price": c.price, "priceCurrency": "TRY", "availability": "https://schema.org/InStock" },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": base },
          { "@type": "ListItem", "position": 2, "name": "Kurslarımız", "item": `${base}/kurslarimiz` },
          { "@type": "ListItem", "position": 3, "name": c.name, "item": `${base}/kurs/${slug}` }
        ]
      }
    ];
    if (faqs.length > 0) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(f => ({
          "@type": "Question",
          "name": f.q,
          "acceptedAnswer": { "@type": "Answer", "text": f.a }
        }))
      });
    }
    schemas.forEach((s, i) => {
      const id = `ld-course-${i}`;
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.type = "application/ld+json"; document.head.appendChild(el); }
      el.textContent = JSON.stringify(s);
    });
    return () => {
      schemas.forEach((_, i) => { const el = document.getElementById(`ld-course-${i}`); if (el) el.remove(); });
    };
  }, [slug, c, faqs]);

  if (!c) return <Navigate to="/kurslarimiz" replace/>;
  const Icon = ICONS[c.icon] || Car;

  return (
    <>
      <SEO title={c.seo_title} description={c.seo_desc} canonical={`https://www.estemsurucukursu.com/kurs/${slug}`}/>
      <section className="px-4 md:px-8 py-12 md:py-16 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <div className="nb-badge mb-4"><Trophy weight="fill" size={14}/> Gebze&apos;nin #1 {c.code} Sınıfı Kursu</div>
            <h1 className="font-heading font-bold text-4xl md:text-6xl tracking-tight leading-[1.05]">{c.hero_h1}</h1>
            <p className="mt-6 text-lg text-brand-ink/80">{c.intro}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button
                onClick={() => setPriceModal(true)}
                data-testid={`course-${slug}-price-btn`}
                className="nb-btn !px-8 !py-4 flex items-center gap-2">
                <Coin weight="fill" size={18}/> Fiyatları Gör
              </button>
              <Link to="/basla" className="nb-btn-secondary !px-6 !py-4" data-testid={`course-${slug}-register-btn`}>
                Kayıt Ol <ArrowRight weight="bold"/>
              </Link>
              <a href="https://wa.me/+905436566346" target="_blank" rel="noreferrer" className="nb-btn-outline !px-6 !py-4"><WhatsappLogo weight="bold"/> WhatsApp</a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="rounded-2xl bg-brand-primary text-white p-8">
              <Icon size={64} weight="duotone"/>
              <div className="font-heading font-bold text-5xl mt-4">{c.code}</div>
              <div className="mt-1 text-sm text-white/80">{c.name}</div>
              <div className="mt-6 space-y-2 text-sm text-white/90">
                <div className="flex items-center gap-2"><Clock weight="fill"/> {c.duration}</div>
                <div className="flex items-center gap-2"><CheckCircle weight="fill"/> Min. Yaş: {c.min_age}</div>
                <div className="flex items-center gap-2"><ShieldCheck weight="fill"/> MEB onaylı sertifika</div>
                <div className="flex items-center gap-2"><Lightning weight="fill"/> Online kayıt mümkün</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <div className="nb-card p-8">
            <h2 className="font-heading font-bold text-2xl uppercase mb-4">Bu sınıfla ne yapabilirsin?</h2>
            <ul className="space-y-3">{c.benefits.map((b,i)=>(<li key={i} className="flex items-start gap-2"><CheckCircle weight="fill" className="text-brand-primary shrink-0 mt-1"/> {b}</li>))}</ul>
          </div>
          <div className="nb-card p-8 bg-brand-primarySubtle">
            <h2 className="font-heading font-bold text-2xl uppercase mb-4">Neden Estem?</h2>
            <ul className="space-y-3">{c.why_us.map((b,i)=>(<li key={i} className="flex items-start gap-2"><Star weight="fill" className="text-brand-primary shrink-0 mt-1"/> {b}</li>))}</ul>
          </div>
        </div>

        <div className="mt-12 nb-card p-8 md:p-12 bg-white">
          <h2 className="font-heading font-bold text-3xl uppercase">{c.code} Sınıfı Detayları</h2>
          <p className="mt-4 text-lg leading-relaxed text-brand-ink/80">{c.long_content}</p>
        </div>

        <div className="mt-12 rounded-2xl bg-brand-ink text-white p-10 md:p-16 text-center">
          <div className="text-sm font-bold uppercase tracking-widest text-brand-primary">Karar zamanı</div>
          <h2 className="font-heading font-bold text-4xl md:text-6xl tracking-tight mt-3">Bugün başla.<br/>Bu ay direksiyondan kalk.</h2>
          <p className="mt-4 opacity-80">5 dakika sürüyor. Tek ihtiyacın TC kimlik numaran.</p>
          <Link to="/basla" className="mt-8 inline-flex nb-btn !px-10 !py-5 !text-base">{c.code} Kursuna Kayıt Ol <ArrowRight weight="bold"/></Link>
        </div>

        {/* FAQ Section */}
        {faqs.length > 0 && (
          <div className="mt-14">
            <h2 className="font-heading font-bold text-3xl uppercase mb-6">{c.code} Hakkında Sık Sorulan Sorular</h2>
            <div className="space-y-3">
              {faqs.map((f, i) => (
                <div key={i} className="nb-card overflow-hidden bg-white">
                  <details className="group">
                    <summary className="px-6 py-5 flex items-center justify-between cursor-pointer list-none font-semibold text-base text-brand-ink gap-4">
                      {f.q}
                      <span className="shrink-0 text-brand-primary transition-transform group-open:rotate-180">▾</span>
                    </summary>
                    <div className="px-6 pb-5 text-stone-600 text-sm leading-relaxed border-t border-stone-100 pt-4">{f.a}</div>
                  </details>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>

      <PriceAdvisorModal
        open={priceModal}
        onClose={() => setPriceModal(false)}
        defaultClass={advisorClass}
      />
    </>
  );
}
